import { isValidTimeZone } from './timeZone';

export class ClinicTimeZoneUnavailableError extends Error {
  constructor(message = 'O fuso horário da clínica não está disponível. Recarregue a página e tente novamente.') {
    super(message);
    this.name = 'ClinicTimeZoneUnavailableError';
  }
}

export class ClinicTimeZoneChangedError extends Error {
  constructor() {
    super('O fuso horário da clínica foi alterado enquanto este formulário estava aberto. Recarregue a página, confira o horário e tente novamente.');
    this.name = 'ClinicTimeZoneChangedError';
  }
}

export const assertClinicTimeZoneMatches = (
  displayedTimeZone: unknown,
  currentTimeZone: unknown,
): string => {
  if (!isValidTimeZone(displayedTimeZone) || !isValidTimeZone(currentTimeZone)) {
    throw new ClinicTimeZoneUnavailableError();
  }

  const displayed = displayedTimeZone.trim();
  const current = currentTimeZone.trim();
  if (displayed !== current) {
    throw new ClinicTimeZoneChangedError();
  }

  return current;
};
